import type {
  SignalsSeriesPayload,
  SignalsQuery,
  InfluxSeriesQuery,
  InfluxMachineStatus,
  SignalMachinesList,
  SignalSourcesList,
  SignalTarget,
} from '../type/SignalsTypes';
import type { HttpClient } from '@/lib/http/HttpClient';

import * as mockImpl from './SignalsApiClient.mock';
import * as realImpl from './SignalsApiClient.real';

// Signals: real orchestrator route (POST /api/signals/last-pass/read) by default.
// Set VITE_ML_SIGNAL_USE_MOCK=true to use the simulated signal generator instead.
// Own flag — signals are backed by signals_provider, not tracabilite_storage.
const signalImpl = import.meta.env.VITE_ML_SIGNAL_USE_MOCK === 'true' ? mockImpl : realImpl;

/** The last passes of a machine's newest part — the /ml card shows what the live model read. */
export function signalsFetchSeries(query: SignalsQuery, http?: HttpClient): Promise<SignalsSeriesPayload> {
  return signalImpl.signalsFetchSeries(query, http);
}

/** The names a machine can take as its signal source (machine form). */
export function signalSourcesReadAll(http?: HttpClient): Promise<SignalSourcesList> {
  return signalImpl.signalSourcesReadAll(http);
}

/** The caller's machines with their signal source (/signals and /ml). */
export function signalMachinesReadAll(http?: HttpClient): Promise<SignalMachinesList> {
  return signalImpl.signalMachinesReadAll(http);
}

export function influxListSignals(target: SignalTarget, http?: HttpClient): Promise<string[]> {
  return signalImpl.influxListSignals(target, http);
}

export function influxMachineStatus(target: SignalTarget, http?: HttpClient): Promise<InfluxMachineStatus> {
  return signalImpl.influxMachineStatus(target, http);
}

export function influxFetchSeries(
  query: InfluxSeriesQuery,
  http?: HttpClient
): Promise<SignalsSeriesPayload> {
  return signalImpl.influxFetchSeries(query, http);
}
